import { Tab } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CustomTabs } from '../../../components/Forms/CustomTabs';
import UseUrlParam from "../../../components/Logic/UseUrlProps";
import RessourceMenu from "../../../components/RessourceMenu";
import ServiceAssociationsComponent from '../../../components/ServiceAssociationsComponent';
import TabPanel from "../../../components/TabPanel";
import { PermissionEnum } from "../../Permission/PermissionEnum";
import { useGetServicesByApproverQuery } from '../../ServiceApi/redux/serviceApiSlice';
import { AbilityContext } from "../../UserApi/logic/Can";
import { useDeleteAuthorizationMutation, useGetAuthorizationByIdQuery } from "../redux/authroisationApiSlice";
import InfoTab from "./tabs/InfoTab";

export interface AuthorisationInfoDialogProps {
    authorisation_uuid: string
    afterDeleteAction?: () => void
}

export const AuthorisationInfoDialog = (props: AuthorisationInfoDialogProps | UseUrlParam) => {

    const params = useParams();
    const urlPropsUuid = (props as UseUrlParam).shouldGetEntityFromUrl ? params["authorisationUuid"] : "";
    const authorisationPropsUuid = (props as AuthorisationInfoDialogProps).authorisation_uuid
    const authorisationUuid = authorisationPropsUuid ?? urlPropsUuid;

    const [value, setValue] = React.useState(0);
    const { t } = useTranslation()
    const { data } = useGetAuthorizationByIdQuery(authorisationUuid);
    const ability = useContext(AbilityContext)

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    if (!data)
        return <></>

    const labels = []
    const tabPanel = []

    labels.push(t("Info") + "")
    tabPanel.push(<TabPanel value={value} index={tabPanel.length}><InfoTab authorisation_uuid={authorisationUuid!} /></TabPanel>)

    if (ability.can(PermissionEnum.SERVICE_READ, data)) {
        labels.push(t("Service associations") + "")
        tabPanel.push(<TabPanel value={value} index={tabPanel.length}><ServiceAssociationsComponent
            getApproversByIdAction={useGetServicesByApproverQuery} approversTitle="Services with authorisation as approver"
            uuid={authorisationUuid!} {...props} /></TabPanel>)
    }

    return (
        <>
            <CustomTabs
                value={value}
                onChange={handleChange}
                rightMenu={
                    <RessourceMenu
                        isAllowedToDelete={(data) => ability.can(PermissionEnum.AUTHORISATION_WRITE, data)}
                        nameOfRessource="authorisation"
                        primaryButtonText={t("Authorisation") + ": " + data.parent_user_email}
                        idToFetch={data.uuid}
                        deleteMutation={useDeleteAuthorizationMutation}
                        getByIdAction={useGetAuthorizationByIdQuery}
                        afterDeleteAction={(props as AuthorisationInfoDialogProps).afterDeleteAction} />
                }
            >
                {labels.map(label => (<Tab key={label} label={label} />))}
            </CustomTabs>
            {tabPanel.map(tabPanel => tabPanel)}
        </>
    )
}